import { HStack, Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { TEXT_VARIANTS } from "@/theme/components/text";

type ReviewCardProps = {
  text: string;
  name: string;
  designation: string;
};

const ReviewCard = (props: ReviewCardProps) => {
  const { text, name, designation } = props;
  const textVariant = useTextVariants();
  return (
    <Stack
      p={6}
      spacing={10}
      justifyContent={"space-between"}
      bgColor={"#F9FAFC"}
      borderRadius={"12px"}
      boxShadow={"lg"}
    >
      <Text variant={TEXT_VARIANTS.LABEL1}>{text}</Text>
      <HStack spacing={6}>
        <Stack spacing={2}>
          <Text variant={textVariant} fontWeight={600}>
            - {designation}
          </Text>
          <Text variant={textVariant} color={"text.100"}>
            {name}
          </Text>
        </Stack>
      </HStack>
    </Stack>
  );
};

export default ReviewCard;
